import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, OnDestroy  } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { ControllerService } from '../shared/services/controller.service';
declare var $: any;




@Component({
    selector: 'app-interview2-question',
    templateUrl: './interview2-question.component.html',
    styleUrls: ['./interview2-question.component.scss'],
    standalone: false
})


export class Interview2QuestionComponent implements OnInit , OnDestroy{
  questions: any = [];
  question: any = null;


  statement = ''
  comment = ''

  maxCount = 0;
  carousel: any;
  currentIndex = 0;
  courseProgress: number = 0;
  options: any;
  readMoreState: boolean = false;
  readMoreString = 'Click here to read some helpful best practice examples.';
  readLessString = 'Read less.';
  readMoreOrLess: string = this.readMoreString;

  ANSWER_MAP = {
    'no' : -1,
    'sometimes': 0,
    'yes': 1
  }

  qpListener = null

  constructor(public controller: ControllerService, private chRef: ChangeDetectorRef, private route: ActivatedRoute) {}

  loadQuestion(index) {
    const question = this.questions[index];


    this.statement = question.statement
    this.comment = question.comment



    this.options = [{
        label: "No",
        valid: question.answer === -1
      },
      {
        label: "Sometimes",
        valid: question.answer === 0
      },
      {
        label: "Yes",
        valid: question.answer === 1
      }
    ]
  }

  ngOnDestroy(): void {
    this.qpListener.unsubscribe()
  }
  ngOnInit() {

    this.questions = this.controller.getSectionComponents().map( (component) => {

      const statement = component.elements.find( ({type}) => type == 'statement').value
      const comment = component.elements.find( ({type}) => type == 'comment').value
      const answer = this.ANSWER_MAP[component.properties.answer.toLowerCase()]

      return {
        statement,
        answer,
        comment
      }

    })

    this.qpListener = this.route.queryParams.subscribe(params => {

        this.loadQuestion(this.controller.getStepItem().index  )


    })

  }
  responded() {
    return this.options && this.options.find((x) => x.selected)
  }

  onNext() {
    this.readMoreState = false;
    this.readMoreOrLess = this.readMoreString;

    this.controller.next()

  }


  onSelect(event, i) {
    if (!this.options.find((x) => x.selected)) {
      const correctIndex = this.options.findIndex((x) => x.valid === true);
      this.options[i].selected = true;
      this.options[correctIndex].showCorrect = (i !== correctIndex);
      this.chRef.detectChanges();
    }
  }}
